<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidadesSolicitante"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="unidadeSolicitanteNome"
                            v-model="model.unidadeSolicitanteId"
                            value-field="unidadeSolicitanteId"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            defaultOptionText="Todas"
                            :options="unidadesExecutante"
                            label="Unidade executante"
                            show-default-option
                            text-field="unidadeNome"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                        />
                    </rkm-col>
                </rkm-row>
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="exames"
                            default-option-text="Todos"
                            label="Exames"
                            show-default-option
                            text-field="exameNome"
                            v-model="model.exameId"
                            value-field="exameId"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="procedimentos"
                            default-option-text="Todos"
                            label="Procedimento"
                            show-default-option
                            text-field="nomeProcedimento"
                            v-model="model.procedimentoId"
                            value-field="procedimentoId"
                        />
                    </rkm-col>
                    <rkm-col>
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                            class="float-left"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                            class="mr-2 float-left"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
                <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                ref="Table"
                hide-filters
                sort-by="nomeProcedimento"
            >
                <template v-slot:cell(nomeProcedimento)="row">
                    <template v-if="row.item.nomeProcedimento === null || row.item.nomeProcedimento === ''|| row.item.nomeProcedimento === 0">
                        SEM PROCEDIMENTO
                    </template>
                    <template v-else>
                        {{ row.item.nomeProcedimento }}
                    </template>
                </template>

                <template v-slot:custom-foot>
                    <rkm-tr>
                        <rkm-th :colspan="cols.length + 7" class="table-td">
                            <rkm-row>
                                <rkm-col cols="6"></rkm-col>
                                <rkm-col cols="6" class="text-right">Total geral de exames: {{ totalExames() }}</rkm-col>
                            </rkm-row>
                        </rkm-th>
                    </rkm-tr>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
import formatsFilter from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, data, object, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    created() {

        this.repositories = {
            relatorio: this.getConectaSusRepository('exameImagem.relatorioProducao'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
            exportacao: this.getConectaSusRepository('exportacao.exameImagem'),
        }

        this.load()
    },
    computed: {
        fields() {
            let fields = [
                {
                    key: 'nomeProcedimento',
                    label: 'Procedimento',
                    sortable: true
                },
                {
                    key: 'exameNome',
                    label: 'Exame',
                    sortable: true
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    sortable: true
                },
                {
                    key: 'unidadeSolicitanteNome',
                    label: 'Unidade solicitante',
                    sortable: true
                },
                {
                    key: 'nomeFantasia',
                    label: 'Unidade executante',
                    sortable: true
                },
                {
                    key: 'nomePrestador',
                    label: 'Prestador',
                    sortable: true
                },
            ]
            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true })
            })

            return fields
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
        unidadesSolicitante(){

            let unidadeSolicitanteOrigem = []
            const data = this.data.model.relatorioProducao

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidadesSolicitante()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                data.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            let verifyUnidade = unidadeSolicitanteOrigem.find(u => u.unidadeSolicitanteId === unidade.unidadeSolicitanteId)

                            if(!verifyUnidade){

                                unidadeSolicitanteOrigem.push({

                                    unidadeSolicitanteId: unidade.unidadeSolicitanteId,
                                    unidadeSolicitanteNome: unidade.unidadeSolicitanteNome
                                })

                            } else {

                                this.resetUnidadesSolicitante()
                            }
                        })
            }

            return unidadeSolicitanteOrigem
        },
        unidadesExecutante(){

            let unidadeExecutanteOrigem = []
            const data = this.data.model.relatorioProducao

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetUnidadeExecutante()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                data.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                        && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                            .map(unidade => {

                                let verifyUnidade = unidadeExecutanteOrigem.find(u => u.unidadeId === unidade.unidadeId)

                                if(!verifyUnidade){

                                    unidadeExecutanteOrigem.push({

                                        unidadeId: unidade.unidadeId,
                                        unidadeNome: unidade.nomeFantasia
                                    })
                                } else {

                                   this.resetUnidadeExecutante()
                                   this.resetDatatable()
                                }
                            })

            }

            return unidadeExecutanteOrigem
        },
        exames(){

            let examesOrigem = []
            const data = this.data.model.relatorioProducao

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetExames()
                this.resetDatatable()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                if(this.verificaUnidade == true){

                    data.filter(agendamento =>
                        moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                            && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId
                            && agendamento.unidadeId === this.model.unidadeId)
                                .map(exame => {

                                    if(examesOrigem){

                                        let verifyExame = examesOrigem.find(u =>  u.exameId === exame.exameId)

                                        if(!verifyExame){

                                            examesOrigem.push({

                                                exameId: exame.exameId,
                                                exameNome: exame.exameNome
                                            })
                                        } else {

                                            this.resetExames()
                                            this.resetDatatable()
                                        }
                                    }
                                })

                        examesOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
                } else {

                    data.filter(agendamento =>
                        moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                            && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId)
                                .map(exame => {

                                    if(examesOrigem){

                                        let verifyExame = examesOrigem.find(u =>  u.exameId === exame.exameId)

                                        if(!verifyExame){

                                            examesOrigem.push({

                                                exameId: exame.exameId,
                                                exameNome: exame.exameNome
                                            })
                                        } else {

                                            this.resetExames()
                                        }
                                    }
                                })

                            examesOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
                }
            }

            return examesOrigem
        },
        procedimentos(){

            let procedimentosOrigem = []

            const data = this.data.model.relatorioProducao

            if(this.model.periodo.start && this.model.periodo.end){

                this.resetProcedimentos()

                const start = moment(this.model.periodo.start).subtract(1, 'day')
                const end = moment(this.model.periodo.end).add(1, 'day')

                data.filter(agendamento =>
                    moment(agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                        && agendamento.unidadeSolicitanteId === this.model.unidadeSolicitanteId
                        && agendamento.unidadeId === this.model.unidadeId
                        && agendamento.exameId === this.model.exameId)
                            .map(procedimento => {

                                let verifyProcedimento = procedimentosOrigem.find(u => u.procedimentoId === procedimento.procedimentoId)

                                if(!verifyProcedimento){

                                    procedimentosOrigem.push({

                                        procedimentoId: procedimento.procedimentoId,
                                        nomeProcedimento: procedimento.nomeProcedimento ?? 'Sem procedimento'
                                    })
                                } else {

                                    this.resetProcedimentos()
                                }
                            })
            }

            return procedimentosOrigem
        },
    },
    data: () => ({
        additionals: {},
        form: null,
        defaultModel: null,
        model: {
            periodo: {
                start: null,
                end: null,
            },
            exameId: null,
            procedimentoId: null,
            prestadorId: null,
            unidadeSolicitanteId: null,
            unidadeId: null,
        },
        selectedAll: false,
        indeterminate: true,
        selectedCols: [],
        itens: null,
        cols: [],
        totalizadores: null,
        verificaUnidade: false,
    }),
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
        },
        search() {

            this.setLoading()
            this.repositories.relatorio.index(this.prepareData())
                .then(({ data }) => {

                    this.itens = data
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        print() {

            this.setLoading()
            this.repositories.impressao.relatorioProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()
            this.repositories.exportacao
                .exportProducao(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers["content-type"]))
                .finally(() => this.unsetLoading());
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            data.totalExames = this.itens.map(item => item.quantidade)
                .reduce((accumulator,value) => accumulator + value,0)

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            this.formateDates(data.periodo, ['start', 'end'], 'DD/MM/YYYY')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.columns.map(c => c.key) : []
        },
        resetUnidadesSolicitante(){

            this.model.unidadeSolicitanteId = null
        },
        resetUnidadeExecutante(){

            this.model.unidadeId = null
        },
        resetExames(){

            this.model.exameId = null
        },
        resetProcedimentos(){

            this.model.procedimentoId = null
        },
        resetDatatable(){

            this.model.statusId = null
            this.model.procedimentoId = null
            this.model.exameId = null
        },
        resetForm() {

            this.model.exame =  null
            this.model.dataNascimento = null
            this.model.unidadeId = null
            this.model.unidadeSolicitanteId = null
            this.model.statusId = null
            this.model.procedimento = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        setDefaultValues() {
            this.model.periodo.start = this.data.model.periodo.start
            this.model.periodo.end = this.data.model.periodo.end
            this.resetDatatable()
        },
        totalExames(){

            return this.itens.map(item => item.quantidade)
                .reduce((accumulator,value) => accumulator + value,0)
        }
    },
    mixins: [repository, error, data, object, stringCase, file],
    watch: {
        'model.unidadeId': function(){

            if(this.model.unidadeId == null || this.model.unidadeId == ''){

                this.verificaUnidade = false

            } else {

                this.verificaUnidade = true
            }
        },
        model: {
            deep: true,
            handler() {

                this.itens = []
                this.totalizadores = null
            }
        },
        selectedCols(newValue){
            this.indeterminate = false
            if (newValue.length > 0 && newValue.length != this.cols.length) {
                this.indeterminate = true
            }
        }
    },
    props: {
        data: { type: Object, required: true }
    }
}
</script>

<style scoped>
    .dropdown>>>.auto-scroll {
        max-height: 400px;
        overflow-y: auto;
        width: 400px;
    }
</style>